<div style="display: flex;">
    <div style="flex-grow: 0; width: 90px;">
        <app-select-filter
                [elements]="countries"
                [filterElementProcessor]="filterDialingCode"
                [parentFormGroup]="parentFormGroup"
                noEntriesFoundLabel="Aucun indicatif téléphonique trouvé"
                parentFormControlName="dialingCode">
            <ng-template let-element='element' template-content>
                <span [class]="'flag-icon flag-icon-' +  element.value.toLowerCase()"></span>
                +{{element.dialingCode}}
            </ng-template>
        </app-select-filter>
    </div>
    <div style="flex-grow: 1;">
        <app-input-text [parentFormGroup]="parentFormGroup" parentFormControlName="number"></app-input-text>
        <div *ngIf="numberControl.errors" class='danger' style="font-size:  0.8em;">Veuillez renseigner un numéro de téléphone valide</div>
    </div>
</div>
